import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-ver-documentos-empresa',
  templateUrl: './ver-documentos-empresa.component.html',
  styleUrls: ['./ver-documentos-empresa.component.scss']
})
export class VerDocumentosEmpresaComponent implements OnInit {

  constructor(
    private router: Router,
    public util: UtilService,
    private ajax: AjaxService,
    private location: Location
    
  ) { }

  ngOnInit() {
  }

  voltar(){
    //this.router.navigate(['/ver-documentos-empresa']);
    this.location.back()
  }

}
